import apiService from '../../../services/api'

/**
 * Promo API Service
 * Сервис для работы с промокодами
 * Endpoints:
 *   POST /api/promo/          — активация промокода
 *   GET  /api/promo/{code}/   — превью промокода (информация до активации)
 *   GET  /api/topup/          — пакеты пополнения с promo_bonus_crystals, best_promo, active_promos
 */

/**
 * Активировать промокод
 * @param {string} code - Код промокода
 * @returns {Promise<{result: boolean}>} Результат активации
 */
export const activatePromo = async (code) => {
  try {
    const response = await apiService.makeRequest('/api/promo/', {
      method: 'POST',
      body: JSON.stringify({ code })
    })

    // Проверяем ошибки бэкенда
    if (response.error) {
      throw new Error(response.error)
    }

    // Успешный ответ: { promo: { result: true } }
    if (response.promo?.result === true) {
      return { result: true }
    }

    // Неизвестный формат ответа
    throw new Error('error backend')
  } catch (error) {
    console.error('Ошибка активации промокода:', error)
    throw error
  }
}

/**
 * Получить превью промокода (информация до активации)
 * @param {string} code - Код промокода
 * @returns {Promise<Object|null>} Объект промокода или null если не найден
 *
 * Возвращает объект с полями:
 *   code: string
 *   percent: number
 *   multi_deposit: boolean
 *   api_enabled: boolean
 *   status: 'can_activate' | 'already_active' | 'used' | 'expired' | 'activation_closed' | 'limit_reached' | null
 *   active: boolean
 *   minutes_left: number | null
 */
export const previewPromo = async (code) => {
  try {
    const response = await apiService.makeRequest(`/api/promo/${code}/`)

    // Если промокод не найден — возвращаем null
    if (!response.promo) {
      return null
    }

    return response.promo
  } catch (error) {
    console.error('Ошибка получения превью промокода:', error)
    throw error
  }
}

/**
 * Получить данные пополнения с промо-информацией
 * Расширенный запрос /api/topup/, возвращающий также best_promo и active_promos
 * @returns {Promise<{topup: Array, best_promo: Object|null, active_promos: Array}>}
 */
export const fetchTopupWithPromo = async () => {
  try {
    const response = await apiService.makeRequest('/api/topup/')

    return {
      topup: response.topup || [],
      best_promo: response.best_promo || null,
      active_promos: response.active_promos || []
    }
  } catch (error) {
    console.error('Ошибка получения данных пополнения с промо:', error)
    throw error
  }
}

export default {
  activatePromo,
  previewPromo,
  fetchTopupWithPromo
}
